import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { apis } from '../api/index.js';
import { Row, Col, Button, Icon, Modal, message } from 'antd';
import printLogo from '../imgs/print-logo.png';
import ReactToPrint from 'react-to-print';
import PrintReport from './PrintReport.js';
import { getSex, formatDA, getImageWithToken, eventListener } from '../utils';
import { reportInfo } from '../utils';
const { confirm } = Modal;
const productionId = '101';
class Preview extends Component {
  btnPrint = React.createRef;
  static propTypes = {
    server: PropTypes.object,
    match: PropTypes.object,
    user: PropTypes.object,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const roleInfo = props.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.state = {
      applicationId: props.match.params.applicationId,
      report: {},
      reportType: 'image',
      isAnonymity,
    };
  }

  componentDidMount() {
    this.getReportInfo();

    if (document.addEventListener) {
      document.addEventListener('webkitvisibilitychange', function() {
        let [pageId, moduleId, elementId] = ['10021', 'mk0004', ''];
        const eventData = { productionId, pageId, moduleId };
        if (document.webkitVisibilityState === 'visible') elementId = 'ns-006';
        else if (document.webkitVisibilityState === 'hidden')
          elementId = 'ns-004';
        elementId && eventListener({ ...eventData, elementId });
      });
    }
  }

  getReportInfo = async () => {
    const { applicationId } = this.state;
    const data = await reportInfo(applicationId);
    this.setState({ report: data });
  };

  close = () => {
    const [pageId, moduleId, elementId] = ['10021', 'mk0004', 'ns-001'];
    eventListener({ productionId, pageId, moduleId, elementId });
    window.close();
  };

  printReport = () => {
    const { report } = this.state;
    apis.printReport(report.diagId).then(res => {
      if (res.code === '0') {
        const { report } = this.state;
        this.setState({ report: { ...report, state: 30 } });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  printConfirm = () => {
    const [pageId, moduleId, elementId] = ['10021', 'mk0004', 'ns-002'];
    eventListener({ productionId, pageId, moduleId, elementId });
    const { report } = this.state;
    const { diagId } = report;
    apis.permitPrintReport(diagId).then(res => {
      if (res.code === '0') {
        if ([201, 20].includes(report.state)) {
          confirm({
            title: '提示',
            content: '夜间急诊报告非正式报告，继续打印吗？',
            okText: '继续打印',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              document.getElementById('btnPrint').click();
            },
          });
        } else document.getElementById('btnPrint').click();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getImgs = report => {
    const subVos = report.subVos || [];
    const selectedVos = subVos.filter(item => item.selectFlag);
    const len = selectedVos.length;
    if (len <= 0) return;
    return subVos.map((item, index) => {
      let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
      return (
        <>
          {item.selectFlag && (
            <span id={`preview-img${index}`} key={index}>
              {getImageWithToken(url, `preview-img${index}`, len)}
            </span>
          )}
        </>
      );
    });
  };
  changeReport = () => {
    const [pageId, moduleId, elementId] = ['10021', 'mk0004', 'ns-003'];
    eventListener({ productionId, pageId, moduleId, elementId });
    const { reportType } = this.state;
    this.setState({ reportType: reportType === 'image' ? 'text' : 'image' });
  };
  render() {
    const { report, reportType, isAnonymity } = this.state;
    if (report) {
      //影像所见和诊断建议内容格式转换
      let radiography = report.radiographyDescription || '';
      radiography = radiography.replace(/\r\n/g, '<br />');
      radiography = radiography.replace(/\n/g, '<br />');

      let diagnosis = report.diagnosisDescription || '';
      diagnosis = diagnosis.replace(/\r\n/g, '<br />');
      diagnosis = diagnosis.replace(/\n/g, '<br />');

      const signatureUrl = process.env.PUBLIC_URL + '/imgs/signature/';
      const institutionId = report.institutionId;
      return (
        <div>
          <div className="preview-report preview-report-margin">
            <div className="title">
              <p className="title-1">{report.reportTitle}</p>
              <p className="title-2">检查报告单</p>
            </div>
            {institutionId === 100109 ? null : (
              <div className="institution report-instution">
                <p>送检机构：{report.institutionName}</p>
                <p>检查日期：{report.studyDateTime}</p>
              </div>
            )}

            <div className="report-user">
              <Row>
                <Col span={12}>
                  <p>姓名：{isAnonymity ? '***' : report.patName}</p>
                </Col>
                <Col span={6}>
                  <p>性别：{getSex(report.patSex)}</p>
                </Col>
                <Col span={6}>
                  <p>年龄：{report.patAge}</p>
                </Col>
                <Col span={12}>
                  <p>患者编号：{report.patId}</p>
                </Col>
                <Col span={12}>
                  <p>住院号：{report.hospitalizedNumber}</p>
                </Col>
                <Col span={12}>
                  <p>检查类型：{report.modality}</p>
                </Col>
                <Col span={12}>
                  <p>送检时间：{report.studyDateTime}</p>
                </Col>
                <Col span={12}>
                  <p>检查编号：{report.accessionNumber}</p>
                </Col>
                <Col span={12}>
                  <p>影像编号：{report.imagesNumber}</p>
                </Col>
                <Col span={12}>
                  <p>检查部位：{report.applicationItem}</p>
                </Col>
                {report.critical && (
                  <Col span={12}>
                    <Icon type="check-square" theme="filled" />
                    危急值
                  </Col>
                )}
              </Row>
            </div>
            {reportType === 'image' && (
              <div className="preview-img">{this.getImgs(report)}</div>
            )}

            <Row gutter={60} className="preview-content">
              <Col span={24}>
                <p className="title">影像所见</p>
                <div
                  className="content report-cont"
                  dangerouslySetInnerHTML={{ __html: radiography }}
                ></div>
              </Col>
            </Row>
            <Row className="preview-content">
              <Col span={24}>
                <p className="title">诊断建议</p>
                <div
                  className="content report-cont"
                  dangerouslySetInnerHTML={{ __html: diagnosis }}
                ></div>
              </Col>
            </Row>

            <div className="printer-footer">
              <div className="print-doctor-names">
                {institutionId === 100109 && (
                  <span className="item">检查日期：{report.studyDateTime}</span>
                )}

                <span className="item">
                  九峰报告医生：
                  {report.reportSignatureImage ? (
                    <img
                      className="signature-img"
                      src={signatureUrl + report.reportSignatureImage}
                      alt=""
                    />
                  ) : (
                    report.reportSignature
                  )}
                </span>
                {report.verifyUserName && (
                  <span className="item">
                    九峰审核医生：
                    {report.verifySignatureImage ? (
                      <img
                        className="signature-img"
                        src={signatureUrl + report.verifySignatureImage}
                        alt=""
                      />
                    ) : (
                      report.verifySignature
                    )}
                  </span>
                )}
                {report.verify2Signature && (
                  <span className="item">
                    九峰审核医生2：
                    {report.verify2SignatureImage ? (
                      <img
                        className="signature-img"
                        src={signatureUrl + report.verify2SignatureImage}
                        alt=""
                      />
                    ) : (
                      report.verify2Signature
                    )}
                  </span>
                )}
              </div>

              <div className="print-date">
                {[20, 201].includes(report.state) && (
                  <div className="printer-warning-tip">
                    风险提示：此为夜间急诊报告，请以正式报告为准
                  </div>
                )}
                {institutionId === 100109 ? (
                  <>九峰医疗远程影像诊断中心合作</>
                ) : (
                  <>
                    <img className="print-logo" alt="" src={printLogo} />
                    &nbsp;&nbsp;江西九峰远程医学影像诊断中心
                  </>
                )}

                <span className="print-time">
                  打印日期：{formatDA(new Date())}
                </span>
                <p className="print-tip">
                  影像检查资料，仅为临床诊断提供参考！
                </p>
              </div>
            </div>
          </div>
          <div className="print-btns print-report-btns">
            <Button className="btn-print-close" onClick={this.close}>
              <Icon type="eye-invisible" theme="filled" />
              关闭预览
            </Button>
            <div className="print-submit">
              <Button
                className="btn-print-do btn-print-cover"
                onClick={this.printConfirm}
              >
                <Icon type="printer" theme="filled" />
                打印报告
              </Button>
              <ReactToPrint
                trigger={() => (
                  <Button className="btn-print-do" id="btnPrint">
                    <Icon type="printer" theme="filled" />
                    打印报告
                  </Button>
                )}
                content={() => this.componentRef}
                onAfterPrint={() => this.printReport()}
              />
            </div>
            <Button className="btn-print-close" onClick={this.changeReport}>
              <Icon type="file-text" theme="filled" />
              {reportType === 'image' ? '查看文字报告' : '查看图文报告'}
            </Button>
          </div>
          <div style={{ display: 'none' }}>
            <div ref={el => (this.componentRef = el)}>
              <PrintReport
                report={this.state.report}
                diagId={this.state.report.diagId}
                reportType={this.state.reportType}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(Preview);
